// extracted by mini-css-extract-plugin
export var nav = "slideshow-module--nav--Aw7Ge";
export var carousel = "slideshow-module--carousel--1Pn2f";
export var slide = "slideshow-module--slide--r794u";